import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAfsls } from './thunks';
import { AfslViewModel, BulkCommonState } from './types';

export const initialState: BulkCommonState = {
  afsls: { afsls: [] },
  models: [],
};

export const commonSlice = createSlice({
  name: '@@bulk/common',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAfsls.fulfilled, (state, action: PayloadAction<AfslViewModel>) => {
      state.afsls = action.payload;
    });
  },
});
